import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/villages/villageList',
            name: 'villages_villageList',
            component: () => import("./views/villageList.vue"),
            meta: {
                hasBar: true
            }
        },
    ];
};